import { default as EChartsReact, default as ReactEcharts } from "echarts-for-react";
import _ from "lodash";
import { DateTime, Interval } from "luxon";
import { useMemo, useState } from "react";
import { hexColor } from "../../../../../enums/colors";
import { splitEventByHour } from "../../../../../lib/calculations";
import { useAppStore } from "../../../../../stores/RootStore";
import { DateShift, Event, FShift } from "../../../../../types/types";

// 0: "equipment_item_id"
// 1: "event_date"
// 2: "shift_date"
// 3: "start"
// 4: "start_ts"
// 5: "finish"
// 6: "finish_ts"
// 7: "duration"
// 8: "state"
// 9: "equipment_item_status"
// 10: "personnel_id"
// 11: "equipment_item_division_id"
// 12: "personnel_division_id"
// 13: "state_changed"
// 14: "status_changed"
// 15: "person_changed"

export function HourHeatMap({events, shift, height = 60, width}: {events: Event[]; shift: DateShift; height: number; width: string | number;}) {
    const {theme} = useAppStore()
    const [ref, setRef] = useState<EChartsReact | null>();
    const [hours, setHours] = useState<any[]>([])
  

    const shiftDuration = shift.end_time.toSeconds() - shift.start_time.toSeconds();

    const chartData = useMemo(() => {
        let hours = Interval.fromDateTimes(shift.start_time, shift.end_time).splitBy({ hour: 1 }).map((date: Interval) => date.start?.hour);
        setHours(hours)
        let workedEvents = events.filter(e => e[8] === "worked")
        let slicedEvents: Event[] = []
        workedEvents.map(e => splitEventByHour(e, slicedEvents))

        let forChart: (number | string)[][] = []

        hours.map((h, hi) => {
            let hourEvents = slicedEvents.filter(e => 
                DateTime.fromSQL(String(e[3])).hour === h
            )
            if(!hourEvents || hourEvents.length === 0) {
                forChart.push([
                    hi,
                    0,
                    0,
                    shift.start_time.hour + h! > 24 ? shift.end_time.set({hour: h}).startOf('hour').toFormat("dd.MM.yyyy HH:mm")! : shift.start_time.set({hour: h}).startOf('hour').toFormat("dd.MM.yyyy HH:mm")!,
                    0
                ])
                return
            }

            forChart.push([
                hi,
                0,
                Math.round((_.sum(hourEvents.map(he => Number(he[7]))) / 3600) * 100),
                DateTime.fromSQL(String(hourEvents[0][1])).set({hour: h}).toFormat("dd.MM.yyyy HH:mm")!,
                Math.round((_.sum(hourEvents.map(he => Number(he[7]))) / 3600) * 100)
            ])
        })
        return forChart
    }, [events])

    const getOptions = () => ({
        anumation: false,
        tooltip: {
        //   position: "top",
        //   formatter: function (params: { marker: any; name: any; value: (number | string | undefined)[] }) {
        //     return ReactDomServer.renderToStaticMarkup(<TooltipHeatmap params={params} />);
        //   }
        },
        toolbox: {
          show: false,
          left: 0,
          feature: {
            saveAsImage: {
              show: true,
              excludeComponents: ['toolbox', 'visualMap']
            },
          }
        },
        grid: {
          left: "0%",
          right: "0%",
          bottom: "0",
          top: "0",
          containLabel: true,
          height: height,
        },
        xAxis: {
          type: 'category',
          position: 'top',
          data: hours,
          axisLabel: {
            formatter: function (val: number) {
              return `${val}:00`;
            },
          },
          splitArea: {
            show: true
          }
        },
        yAxis: {
          type: 'category',
          position: 'right',
          data: [0],
          axisLabel: {
            show: false,
            formatter: function (val: string) {
              return DateTime.fromSQL(val).toFormat("dd.MM");
            },
          },
          splitArea: {
            show: true
          }
        },
        visualMap: {
          show: false,
          min: 0,
          max: 100,
          calculable: true,
          orient: 'horizontal',
          left: 'right',
          top: '0%',
          inRange : {   
            color: theme == 'light' ? [hexColor.background, '#57a773', '#157145' ] : [hexColor.foreground, '#57a773', '#157145' ]//From smaller to bigger value ->
          }
        },
        series: [
          {
            name: 'Загрузка оборудования за',
            type: 'heatmap',
            data: chartData,
            label: {
              show: true,
              formatter: function (params: { marker: any; name: any; value: (number | string | undefined)[] }) {
                return params.value[2];
              },
            },
            emphasis: {
              focus: 'series',
              itemStyle: {
                shadowBlur: 10,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
    });
    
    return (
        <ReactEcharts
            option={getOptions()}
            ref={(e) => { setRef(e);}}
            style={{ width: "100%", height: height + 20}}
            opts={{ renderer: "canvas" }}
        />
    )
}